import { render } from "./PontajRepartizare.vue?vue&type=template&id=639b10b4&scoped=true&ts=true"
import script from "./PontajRepartizare.vue?vue&type=script&lang=ts"
export * from "./PontajRepartizare.vue?vue&type=script&lang=ts"

import "./PontajRepartizare.vue?vue&type=style&index=0&id=639b10b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639b10b4"]])

export default __exports__